import React, { useEffect, useState } from 'react'
import AdminLeftMenu from './backend/AdminLeftMenu';
import { useLocation, useNavigate } from 'react-router-dom';
import { useParams,Link } from "react-router-dom"
import Moment from 'react-moment';
import moment from 'moment';
import { useAuth } from '../contexts/AuthContext';
import PractitionerService from '../services/practitionerService';
import { toast } from 'react-toastify';
//import { adddDays } from 'date-fns'

const Schedule = () => {
  // const tomorrow = addDays(date, 2);
  // console.log(tomorrow);
  //  console.log(info.event.title)
  const [name, setName] = useState("");
  const [scheduledate, setScheduleDate] = useState("");
  const [starttime, setStartTime] = useState("");
  const [endtime, setEndTime] = useState("");
  const [today, setToday] = useState("");
  const [physicianData, setPhysicianData] = useState(null);
  const [isRemoving, setIsRemoving] = useState(false);
  
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const practitionerService = new PractitionerService();
  
  let eventObject;
  let resObject;
  
  useEffect(() => {
    eventObject = JSON.parse(localStorage.getItem('event'));
    console.log("schedule=="+JSON.stringify(eventObject));
    
    if (eventObject) {
      setName(eventObject.full_name || eventObject.first_name || 'Unknown');
    setScheduleDate(eventObject.start_date);
    setStartTime(eventObject.start_time);
    setEndTime(eventObject.end_time);
      setToday(eventObject.start_date);
      setPhysicianData(eventObject);
    }
  }, []);

  const handleRemovePhysician = async () => {
    if (!currentUser?.uid || !physicianData) {
      toast.error('Unable to remove physician. Please try again.');
      return;
    }

    // Confirm removal
    const physicianName = physicianData.full_name || physicianData.first_name || 'this physician';
    const confirmRemoval = window.confirm(
      `Are you sure you want to remove ${physicianName} from your profile? This will also remove all associated appointments from your calendar.`
    );
    
    if (!confirmRemoval) {
      return;
    }

    try {
      setIsRemoving(true);
      
      // Find the physician by NPI or ID
      const practitionerId = physicianData.npi || physicianData.id;
      if (!practitionerId) {
        toast.error('Unable to identify physician to remove.');
        return;
      }

      await practitionerService.removePractitioner(practitionerId);
      
      toast.success(`${physicianName} has been removed from your profile.`);
      
      // Navigate back to calendar or dashboard after a brief delay
      setTimeout(() => {
        navigate('/calendar');
      }, 1500);
      
    } catch (error) {
      console.error('Error removing physician:', error);
      toast.error('Failed to remove physician. Please try again.');
    } finally {
      setIsRemoving(false);
    }
  };

  const { info } = useParams()
  const toUpperCaseFilter = (d) => {
    return d.toUpperCase();
}; 

  return (
    <>
    
      <div className="offcanvas offcanvas-start" id="demo">
        <AdminLeftMenu />
      </div>
      <div className="rightpane">
        <div className='container'>
          <div className="row justify-content-center">
            <h6>{moment(today).format('ll')}</h6>
            <div className="col-md-2 avatarwrap">
              <div className="avname">
                <h2>SJ</h2>
                <span className="avedit"> <Link to='#' className='a-g-link' data-bs-toggle="modal" data-bs-target="#scheduleRemovePhysicianModal"><i className="fa fa-pencil"></i></Link></span>
              </div>
              <h6 className='text-center' htmlFor="disabledFieldsetCheck">{physicianData?.prefix || 'Dr.'} {name}</h6>
              {physicianData?.specialty && (
                <p className='text-center text-muted small'>({physicianData.specialty})</p>
              )}
            </div>
            {/* <div className="col-md-2 avatarwrap">
              <div className="avname1">
                <h2>SJ</h2>
                <span class="avedit"> <Link to='#' className='a-g-link' data-bs-toggle="modal" data-bs-target="#removephysicians"><i class="fa fa-pencil"></i></Link></span>
              </div>
              <h6 className='text-center' for="disabledFieldsetCheck">Dr. Sarah Jonas</h6>
            </div> */}

            <div className="modal smallsize" id="scheduleRemovePhysicianModal">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-body">
                    <button type="button" className="btn-close loginmdl" data-bs-dismiss="modal"></button>
                    <div className='row'>
                      <div className='modalWrap'>
                        <div className='removehdr'>
                          <Link to='#' className='active'>Color</Link>
                          <Link to='#'>Notifications</Link>
                        </div>
                        <div className='addmodalbdy'>
                          <h4>Physician</h4>
                          <div className="dr-name p-0 d-flex">
                            <div className='addnamephy'>
                              <b><span className="dot-box2"></span> {physicianData?.prefix || 'Dr.'} {physicianData?.full_name || name} </b>
                              <span>({physicianData?.specialty || 'General Practice'})</span>
                              {physicianData?.npi && (
                                <div className="text-muted small">NPI: {physicianData.npi}</div>
                              )}
                            </div>
                          </div>
                          <div className='colorbox'>
                            <h4>Color</h4>
                            <div className='selctClr'>
                              <div>
                                <input id="radio-1" className="radio-custom" name="radio-group" type="radio" />
                                <label htmlFor="radio-1" className="radio-custom-label rc1"></label>
                              </div>
                              <div>
                                <input id="radio-2" className="radio-custom" name="radio-group" type="radio" />
                                <label htmlFor="radio-2" className="radio-custom-label rc2"></label>
                              </div>
                              <div>
                                <input id="radio-3" className="radio-custom" name="radio-group" type="radio" />
                                <label htmlFor="radio-3" className="radio-custom-label rc3"></label>
                              </div>

                              <div>
                                <input id="radio-4" className="radio-custom" name="radio-group" type="radio" />
                                <label htmlFor="radio-4" className="radio-custom-label rc4"></label>
                              </div>
                              <div>
                                <input id="radio-5" className="radio-custom" name="radio-group" type="radio" defaultChecked />
                                <label htmlFor="radio-5" className="radio-custom-label rc5"></label>
                              </div>
                              <div>
                                <input id="radio-6" className="radio-custom" name="radio-group" type="radio" />
                                <label htmlFor="radio-6" className="radio-custom-label rc6"></label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='text-center'>
                          <input type='button' className='btn btn-primary w-100' value='Update'></input>
                          <span className='linebreak'>OR</span>
                          <button 
                            type='button' 
                            className='btn btn-danger w-100 removebtn' 
                            onClick={handleRemovePhysician}
                            disabled={isRemoving}
                          >
                            {isRemoving ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                Removing...
                              </>
                            ) : (
                              'Remove from Profile'
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-12'>
              <div className="row align-items-center">
                <div className="col-md-12">
                  <div className="schedule-boxleft">
                    <div className="yearbox" style={{ "background-color": "#F4F1DE", "border-bottom": "0px" }}>
                      <h2>Schedule</h2>
                      <h2 style={{ "color": "#e28563" }}>
                      {moment(today).format('ll')}
                         </h2>
                      <span><Link to="#" className="me-4 text-dark"><i className="fa fa-chevron-left"></i></Link>
                        <Link to="#" className="text-black"><i className="fa fa-chevron-right"></i></Link></span>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-2"><p style={{ "margin-left": "20px" }}>{starttime} AM</p></div>
                      <div className="col-md-10">
                        <div className="upschedulebox bdrleft mb-4">
                          <div className="uphdr">
                          </div>
                          <div className="myphy-boxleft">
                            <div className='row'>
                              <div className='col-1 text-center mb-3'><i className="fa fa-building"></i></div>
                              <div className='col-9 mb-3 ps-0'>{physicianData?.location || physicianData?.hospital || 'Unknown Location'}</div>
                              <div className="col-2 upcom-time ms-auto">{starttime}-{endtime}</div>
                              <div className='col-1 text-center'><i className="fa fa-medkit"></i></div>
                              <div className='col-11 ps-0'>{physicianData?.procedure || physicianData?.description || 'Unknown Procedure'}</div>
                              
                              {/* Additional appointment details */}
                              {physicianData?.status && (
                                <>
                                  <div className='col-1 text-center mt-2'><i className="fa fa-info-circle"></i></div>
                                  <div className='col-11 ps-0 mt-2'>
                                    <span className={`badge ${physicianData.status === 'booked' ? 'bg-success' : 'bg-secondary'}`}>
                                      {physicianData.status.charAt(0).toUpperCase() + physicianData.status.slice(1)}
                                    </span>
                                  </div>
                                </>
                              )}
                              
                              {physicianData?.priority && (
                                <>
                                  <div className='col-1 text-center mt-2'><i className="fa fa-flag"></i></div>
                                  <div className='col-11 ps-0 mt-2'>
                                    Priority: <span className="text-capitalize">{physicianData.priority}</span>
                                  </div>
                                </>
                              )}
                              
                              {physicianData?.duration && (
                                <>
                                  <div className='col-1 text-center mt-2'><i className="fa fa-clock-o"></i></div>
                                  <div className='col-11 ps-0 mt-2'>Duration: {physicianData.duration} minutes</div>
                                </>
                              )}
                              
                              {physicianData?.practitionerNPI && (
                                <>
                                  <div className='col-1 text-center mt-2'><i className="fa fa-id-card"></i></div>
                                  <div className='col-11 ps-0 mt-2'>
                                    <small className="text-muted">Provider NPI: {physicianData.practitionerNPI}</small>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="row align-items-center">
                      <div className="col-md-2"><p style={{ "margin-left": "20px" }}>9:00 AM</p></div>
                      <div className="col-md-10">
                        <div className="upschedulebox bdrleft mb-4">
                          <div className="uphdr">
                          </div>
                          <div className="myphy-boxleft">
                            <div className='row'>
                              <div className='col-1 text-center mb-3'><i className="fa fa-building"></i></div>
                              <div className='col-9 mb-3 ps-0'>Saint Francis Hospital</div>
                              <div className="col-2 upcom-time ms-auto">8 - 10:30am</div>
                              <div className='col-1 text-center'><i className="fa fa-medkit"></i></div>
                              <div className='col-11 ps-0'>Right shoulder arthroscopy w/ subacrom/ial decompression, rotator cuff repair</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="row align-items-center">
                      <div className="col-md-2"><p style={{ "margin-left": "20px" }}>10:00 AM</p></div>
                      <div className="col-md-10">
                        <div className="upschedulebox bdrleft mb-4">
                          <div className="uphdr">
                          </div>
                          <div className="myphy-boxleft">
                            <div className='row'>
                              <div className='col-1 text-center mb-3'><i className="fa fa-building"></i></div>
                              <div className='col-9 mb-3 ps-0'>Saint Francis Hospital</div>
                              <div className="col-2 upcom-time ms-auto">8 - 10:30am</div>
                              <div className='col-1 text-center'><i className="fa fa-medkit"></i></div>
                              <div className='col-11 ps-0'>Right shoulder arthroscopy w/ subacrom/ial decompression, rotator cuff repair</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )


};
export default Schedule;
